import React, { FC } from 'react';
import { FieldErrors } from 'react-hook-form';

import { Stepper } from '../../Stepper';

interface StepInterface {
    name: string;
}
interface FormStepperProps {
  activeStep: number;
  steps: StepInterface[];
  errors: FieldErrors;
  onStepClick?: (stepNumber: number) => void;
}

export const FormStepper: FC<FormStepperProps> = ({
  activeStep, steps, errors,
  onStepClick,
}) => {
  const extractInvalidSteps = (obj: FieldErrors, seen = new Set(), invalidSteps = new Set<number>()): number[] => {
    if (!obj || seen.has(obj)) return Array.from(invalidSteps);
    seen.add(obj);

    Object.entries(obj).forEach(([_, value]) => {
      if (value && typeof value === 'object') {
        if ('message' in value && typeof value.message === 'string') {
          const matches = value.message.match(/\{(\d+)\}/g);
          if (matches) {
            matches.forEach((match) => {
              const stepNumber = Number(match.replace(/\{|\}/g, '')); // Extract number
              if (!Number.isNaN(stepNumber)) { // Use Number.isNaN instead
                invalidSteps.add(stepNumber);
              }
            });
          }
        }
        extractInvalidSteps(value as FieldErrors, seen, invalidSteps); // Recursively check nested objects
      }
    });

    return Array.from(invalidSteps);
  };
  const invalidSteps = extractInvalidSteps(errors);

  return (
    <Stepper
      invalidStep={invalidSteps}
      activeStep={activeStep}
      steps={steps}
      onStepClick={(e) => onStepClick && onStepClick(e)}
    />
  );
};
